import {chains} from "../constants";

export default function getChainId(chain: string): number {
  return chains.find((c) => c.symbol === chain)?.id || 1;
}
